var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeakDownBlack2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94934 0.159291C8.16176 -0.0529683 8.50509 -0.0530669 8.71594 0.159291C8.92818 0.371661 8.92817 0.715019 8.71594 0.925893L5.44055 4.20128C5.17247 4.46922 4.81706 4.61628 4.43762 4.61632C4.05819 4.61632 3.70279 4.46918 3.43469 4.20128L0.1593 0.925893C-0.0530964 0.713485 -0.0531036 0.370188 0.1593 0.159291C0.371701 -0.0531006 0.715002 -0.0530934 0.925901 0.159291L4.20129 3.43468C4.32781 3.56075 4.5475 3.56084 4.67395 3.43468L7.94934 0.159291Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakDownBlack2);
export default __webpack_public_path__ + "static/media/beak_down_black2.ba79eceea525cc2b5f2e19c42fa4f1e6.svg";
export { ForwardRef as ReactComponent };